module.exports = __webpack_public_path__ + "static/media/export-icon.46d17db0.svg";